import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowRight14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_23)'>
      <path
        d='M10.1894 6.24997L6.96973 3.0303L8.03039 1.96964L13.0607 6.99997L8.03039 12.0303L6.96973 10.9696L10.1894 7.74997H1L1 6.24997H10.1894Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_23'>
        <rect
          width='14'
          height='14'
          fill='white'
          transform='translate(0 14) rotate(-90)'
        />
      </clipPath>
    </defs>
  </Svg>
);

ArrowRight14.displayName = 'ArrowRight14';
export default ArrowRight14;
